import { GENERAL_CONSTANTS, HowdenApiEnviroment, IHowdenApiInfo, IHowdenApiPaths } from '@howdeniberia/core-front';

export const ApiConfigurations: IHowdenApiInfo[] = [
  {
    name: GENERAL_CONSTANTS.ApiSecurityName,
    paths: {
      local: 'https://localhost:7128',
      development: 'https://how-apisecurity.app-dev.howdeniberia.com',
      staging: 'https://how-apisecurity.app-staging.howdeniberia.com',
      production: 'https://how-apisecurity.app.howdeniberia.com'
    } as IHowdenApiPaths,
    needsToken: true,
    useEnviroment: HowdenApiEnviroment.ENVIROMENT_CHOOSE
  }
] as IHowdenApiInfo[];
